<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I owe Thomas Kovacs a big thank you for <em>Vincent’s Crazy Go-Kart Race</em>. Whenever I had a technical problem with my computer, Thomas was there to help me out. Without his service, this book would not have reached the publisher’s desk.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?69fe213c